import * as React from 'react'

import { cn } from '@/lib/tailwind.utils'

export interface ButtonGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: 'horizontal' | 'vertical'
}

const ButtonGroup = React.forwardRef<HTMLDivElement, ButtonGroupProps>(
  ({ className, orientation = 'horizontal', ...props }, ref) => (
    <div
      ref={ref}
      role="group"
      data-orientation={orientation}
      className={cn(
        'inline-flex w-fit',
        orientation === 'horizontal'
          ? '[&>*]:rounded-none [&>*:first-child]:rounded-l-md [&>*:last-child]:rounded-r-md [&>*:not(:first-child)]:-ml-px'
          : 'flex-col [&>*]:rounded-none [&>*:first-child]:rounded-t-md [&>*:last-child]:rounded-b-md [&>*:not(:first-child)]:-mt-px',
        '[&>*]:relative [&>*:focus-visible]:z-10',
        className,
      )}
      {...props}
    />
  ),
)
ButtonGroup.displayName = 'ButtonGroup'

export { ButtonGroup }
